import { FC } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from 'views/screens/Login'
import EvaluatedLogin from 'views/screens/Login/evaluated'
import LoginMfa from 'views/screens/Login/mfa'
import Register from 'views/screens/Register'
import CertificationRegistration from 'views/screens/CertificationRegistration'
import TrainingRegistration from 'views/screens/TrainingRegistration'
import TrainingCertificateValidation from 'views/screens/TrainingRegistration/validation'
import Forgot from 'views/screens/Forgot'
import GenerateReportsPdf from 'views/screens/Evaluated-User/pages/generate-reports-pdf'

const PublicRouter: FC = () => {
  const isAuthenticated = false

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/mfa" element={<LoginMfa />} />
      <Route path="/login/evaluated" element={<EvaluatedLogin />} />
      <Route path="/register" element={<Register />} />
      <Route path="/certificaciones" element={<CertificationRegistration />} />
      <Route path="/certificaciones/:processId" element={<CertificationRegistration />} />
      <Route path="/entrenamientos/:token" element={<TrainingRegistration />} />
      <Route path="/entrenamientos/reaceptar/:token" element={<TrainingRegistration reacceptMode />} />
      <Route path="/validar-entrenamiento/:id" element={<TrainingCertificateValidation />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path='/generate-user-pdf' element={<GenerateReportsPdf />} />
      {!isAuthenticated && <Route path="*" element={<Navigate to="/" />} />}
    </Routes>
  )
}

export default PublicRouter
